import { render, staticRenderFns } from "./DigiBoardLicenceDetails.vue?vue&type=template&id=d0d9649c&scoped=true&"
import script from "./DigiBoardLicenceDetails.vue?vue&type=script&lang=js&"
export * from "./DigiBoardLicenceDetails.vue?vue&type=script&lang=js&"
import style0 from "./DigiBoardLicenceDetails.vue?vue&type=style&index=0&id=d0d9649c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d9649c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VIcon,VRow})
